import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { apiFetch } from '../../modules/utility';

const apiBase = 'tmw';

const search = ({ params = {}, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.search`,
			params,
			dispatch,
			callback,
		});
	};
};

const getBillToCustomerList = ({ params = {}, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.getBillToCustomerList`,
			params,
			dispatch,
			callback,
		});
	};
};

const getConsigneeCustomerList = ({ params = {}, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.getConsigneeCustomerList`,
			params,
			dispatch,
			callback,
		});
	};
};

const getBillerList = ({ params = {}, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.getBillerList`,
			params,
			dispatch,
			callback,
		});
	};
};

const getTerminalList = ({ params = {}, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.getTerminalList`,
			params,
			dispatch,
			callback,
		});
	};
};

const getDivisionList = ({ params = {}, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.getDivisionList`,
			params,
			dispatch,
			callback,
		});
	};
};

const searchUnbilledOrders = ({ params = {}, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.unbilledOrder.search`,
			params,
			dispatch,
			callback,
		});
	};
};

const searchTmwInvoices = ({ params = {}, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.invoice.search`,
			params,
			dispatch,
			callback,
		});
	};
};

const addTmwOrderComment = ({ params = {}, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `tmwOrderComment.add`,
			params,
			dispatch,
			callback,
		});
	};
};

const mapStateToProps = (state) => {
	return state;
};

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			searchTmw: search,
			getBillToCustomerList,
			getConsigneeCustomerList,
			getBillerList,
			getTerminalList,
			getDivisionList,
			searchUnbilledOrders,
			searchTmwInvoices,
			addTmwOrderComment,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
